// fetch, timed: one `call` step per request (see stepLog.js).
//
// ttfb is send to response headers, total is send to body done. The body is
// read from a clone in the background, so the caller's own read is untouched.
import { mark } from "./stepLog.js";

/** The path with ids and tokens stripped; other hosts (S3) are named by host alone. */
export function callPath(url, base = "http://self") {
  try {
    const u = new URL(url, base);
    if (u.origin !== new URL(base).origin) return u.hostname;
    return u.pathname.replace(/\/[^/]*(\d{4,}|[0-9a-f]{8,})[^/]*/gi, "/:id").slice(0, 60);
  } catch {
    return "?";
  }
}

function sentBytes(body) {
  if (!body) return 0;
  if (typeof body === "string") return body.length;
  return body.size ?? body.byteLength ?? 0;
}

export async function tracedFetch(url, init = {}) {
  const t0 = performance.now();
  const info = { method: (init.method || "GET").toUpperCase(), path: callPath(String(url), globalThis.location?.href || "http://self"), sent: sentBytes(init.body) };
  let res;
  try {
    res = await fetch(url, init);
  } catch (err) {
    const ms = performance.now() - t0;
    mark("call", { ...info, status: 0, ok: false, ms, ttfb: ms, total: ms, why: err?.name });
    throw err;
  }
  const ttfb = performance.now() - t0;
  const done = (recv) => {
    const total = performance.now() - t0;
    mark("call", { ...info, status: res.status, ok: res.ok, ms: total, ttfb, total, recv });
  };
  try {
    res.clone().arrayBuffer().then((b) => done(b.byteLength), () => done(undefined));
  } catch {
    done(undefined);
  }
  return res;
}
